import { cloneDeep } from "lodash";
import { getLeafValue } from "hooks/widget-data/datapoints-api/helper";
const getChartData = (columns, data) => {
    const result = columns.map((col) => {
        const colData = data[col.aggregate];
        const amount = getLeafValue(colData);
        return { ...col,
            name: col.title,
            y: amount ? amount : 0 };
    });
    return result?.filter((i) => i !== null);
};
export const valueBridge = (params) => (args) => {
    const paramsAsValueBridgeColumn = params;
    if (!args.context.staticData.customResult?.length) {
        args.context.staticData.customResult = cloneDeep(params);
    }
    const visitable = args.visitable;
    const data = visitable.data?.[0]?.measures;
    if (data) {
        args.context.staticData.customResult = getChartData(paramsAsValueBridgeColumn, data);
    }
    return [];
};
